import React from "react";
import SortBoolAscendingVariantIcon from "mdi-react/SortAscendingIcon";
import SortBoolDescendingVariantIcon from "mdi-react/SortDescendingIcon";
import { useGrid } from "../../context/GridContext";
import { VariableSizeList } from "react-window";

const VirtualizedTableBody = ({ isDifferent = false }) => {
  const {
    getTableProps,
    classes,
    headerGroups,
    tHeight,
    getTableBodyProps,
    page,
    prepareRow,
    totalSection,
    title,
    viewAllModal,
    showTotal,
  } = useGrid();

  const RenderRow = ({ index, style }) => {
    const row = page[index];
    prepareRow(row);

    return (
      <tr
        {...row.getRowProps()}
        className={classes.tRow}
        style={{
          ...style,
          backgroundColor: row.depth === 1 ? "rgba(250,219,207)" : "",
          color: row.depth === 1 ? "#000" : "",
        }}
      >
        {row.cells?.map((cell) => {
          return (
            <td
              className="text-truncate word-"
              style={{
                ...cell.column.style,
                wordBreak: "break-word",
                whiteSpace:
                  cell.column?.shouldWrap === true ? "normal" : "nowrap",
              }}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
    );
  };
  const getItemSize = (index) => (isDifferent ? 80 : 54);
  return (
    <table className={classes.table} {...getTableProps()}>
      <thead className={classes.tHead}>
        {headerGroups?.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()} className={classes.tRow}>
            {headerGroup.headers?.map((column) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                style={{ ...column.style, wordBreak: "break-word" }}
              >
                <div className="d-flex align-items-center">
                  {column.render("Header")}
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <SortBoolDescendingVariantIcon />
                    ) : (
                      <SortBoolAscendingVariantIcon />
                    )
                  ) : (
                    ""
                  )}
                </div>
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody
        className={classes.tBody}
        style={viewAllModal ? { height: tHeight } : {}}
        {...getTableBodyProps()}
      >
        <VariableSizeList
          height={!page?.length ? 10 : 600}
          itemCount={page.length}
          itemSize={getItemSize}
        >
          {RenderRow}
        </VariableSizeList>
        {!page?.length ? (
          <tr
            className={classes.tRow}
            style={{ textAlign: "center", color: "grey" }}
          >
            <td> No {title}</td>
          </tr>
        ) : null}
        {(!viewAllModal || showTotal) && totalSection && page.length ? (
          <tr className={classes.tRow}>{totalSection}</tr>
        ) : null}
      </tbody>
    </table>
  );
};

export default VirtualizedTableBody;
